module.exports = __webpack_public_path__ + "img/SemImagem.f1ab2885.jpg";